import { gql } from '@apollo/client';
import { SHOWCASE_FIRM } from './ShowcaseFirm.fragment';

export const SHOWCASE_FIRM_REPRESENTATIVE = gql`
  ${SHOWCASE_FIRM}
  fragment ShowcaseFirmRepresentativeFields on showcaseFirmRepresentative {
    id
    name
    phone
    email
    imageUrl
    showcaseFirmId
    createdBy
    updatedBy
    dateCreated
    dateUpdated
    firm {
      ...ShowcaseFirmFields
    }
  }
`;
